import { useEffect, useRef, useState, useCallback } from "react";

import IsLogin from "../../utilities/functions/isLogin";
import { useLocation, useNavigate } from "react-router-dom";
import apiConfig from "../../utilities/apiConfig.json";
import serverConfig from "../../utilities/serverConfig.json";
import constData from "../../utilities/const.json";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PlaceCard from "./placeCard";
import DepartmentPlaceCard from "../department/departmentPlaceCard";
import PlaceImgNotFound from "./../../assets/images/place-not-found.svg";
import isWhitespaceString from "../../utilities/functions/isWhiteSpaceString";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "../../slices/userSlice";
import haveAccess from "../../utilities/functions/haveAccess";
import AddIcon from "./../../assets/images/icons/Google SVGs/add.svg";
import { ReactComponent as ArrowRightAltIcon } from "./../../assets/images/icons/Google SVGs/arrow_right_alt.svg";
import { ReactComponent as Close } from "./../../assets/images/icons/Google SVGs/cancel.svg";
import { ReactComponent as Delete } from "./../../assets/images/icons/Google SVGs/delete.svg";
import { ReactComponent as DeleteIcon } from "./../../assets/images/icons/Google SVGs/delete.svg";
import scrollToTop from "../../utilities/functions/ScrollToTop";
import PlaceSkt from "../../components/Skeletons/PlaceSkt";
import CreatePlaceSkt from "../../components/Skeletons/CreatePlaceSkt";
import FloatLabelInput from "../../components/FloatLabelInput";

const depositOptions = [
    { value: "", label: "درصد بیعانه را انتخاب کنید", disabled: true },
    { value: "0", label: "0" },
    { value: "30", label: "30%" },
    { value: "50", label: "50%" },
    { value: "100", label: "100%" },
];

const PlaceStore = () => {

    const [logIn, setLogIn] = useState();
    const navigate = useNavigate();

    const departmentSearchInputRef = useRef(null);
    const backToDepartmentListModal = useRef()

    const [initialLoad, setInitialLoad] = useState(true)

    const dispatch = useDispatch();
    const { token, roles } = useSelector((state) => state.user);
    const tokenLocal = localStorage.getItem("token");

    const headers = { Authorization: "Bearer " + (token ? token : tokenLocal) };

    // #endregion
    const [loading, setLoading] = useState(false);

    const [clearData, setClearData] = useState(false);
    const [editing, setEditing] = useState(false);
    const [placeID, setPlaceID] = useState();

    const [places, setPlaces] = useState();

    const { search } = useLocation();
    const queryParams = new URLSearchParams(search);
    const pl = queryParams.get("pl") ? queryParams.get("pl") : null; // Getting the value of 'pl' from the query string
    const action = queryParams.get("action") ? queryParams.get("action") : null; // Getting the value of 'action' from the query string

    // #region pages variables
    const [searchValue, setSearchValue] = useState("");
    const [paginationElem, setPaginationElem] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [perPage, setPerPage] = useState(24);
    //  #endregion

    // #region city province
    const [cities, setCities] = useState();
    const [provinces, setProvinces] = useState();
    const [selectedCity, setSelectedCity] = useState("");
    const [selectedProvince, setSelectedProvince] = useState("");
    const [selectedDeposit, setSelectedDeposit] = useState("");
    // #endregion

    // #region assign dep to place
    const [departments, setDepartments] = useState([]);
    const [departmentsList, setDepartmentsList] = useState([]);
    const [department, setDepartment] = useState({
        id: null,
        title: null,
        biography: null,
    });
    const [departmentSearch, setDepartmentSearch] = useState("");

    // data for add dep
    const [allDepartments, setAllDepartments] = useState();

    const [departmentFieldValues, setDepartmentFieldValues] = useState({
        deposit_percentage: '',
        pazirex_patient_service_amount: '',
        pazirex_provider_service_amount: '',
        total_visit_amount: '',
        phone: '',
        biography: ''
    })

    const [newDepartmentFieldValues, setNewDepartmentFieldValues] = useState({ ...departmentFieldValues })

    // #region creation input
    const [isActive, setIsActive] = useState(0);
    const [preview, setPreview] = useState();
    const [placePhoto, setPlacePhoto] = useState();
    const [placeName, setPlaceName] = useState("");
    const [address, setAddress] = useState("");
    const [placeType, setPlaceType] = useState("");
    const [technicalPhoneNumber, setTechnicalPhoneNumber] = useState("");
    const [biography, setBiography] = useState("");
    const [isDepartmentUpdating, setIsDepartmentUpdating] = useState(false);
    // #endregion

    const handleDepartmentFieldUpdate = useCallback(setDepartmentFieldValues, []);
    const handleNewDepartmentFieldUpdate = useCallback(setNewDepartmentFieldValues, []);

    const resetDepartmentFieldValues = () => {
        setDepartmentFieldValues({
            deposit_percentage: '',
            pazirex_patient_service_amount: '',
            pazirex_provider_service_amount: '',
            total_visit_amount: ''
        })
    }

    const placeStoreAPI = () => {

        // create a new FormData object and append the file to it
        setLoading(true);

        const formData = new FormData();
        formData.append("title", placeName);
        formData.append("province_id", selectedProvince);
        formData.append("city_id", selectedCity);
        formData.append("address", address);
        formData.append("technical_phone", technicalPhoneNumber);
        formData.append("type", placeType);
        formData.append("is_active", isActive);

        if (placePhoto) {
            formData.append("files[]", placePhoto.target.files[0]);
        }

        Object.entries(departmentFieldValues).map(([key, value]) => {
            formData.append(key, value)
        })

        axios
            .post(
                serverConfig.server.url + apiConfig.api.storeAPIs.storePlace,
                formData,
                {
                    headers,
                }
            )
            .then((response) => {
                setLoading(false);
                if (response.data.status === "success") {
                    toast.success(response.data.message);
                    setClearData(true);
                    getPlacesAPI();
                    navigate("/place-store");
                } else {
                    if (typeof response.data.errors === typeof "String") {
                        toast.error(response.data.errors);
                    } else {
                        response.data.errors.forEach((element) => {
                            toast.error(element);
                        });
                    }
                }
            })
            .catch((error) => {
                setLoading(false);
                toast.error("Error making API call:", error);
            });
    };

    const placeUpdateAPI = () => {

        const fieldExceptions = ['is_active', 'province_id', 'city_id', 'type', 'files']

        setLoading(true);

        const formData = new FormData();

        formData.set("title", placeName ?? '');
        formData.set("province_id", selectedProvince ?? '');
        formData.set("city_id", selectedCity ?? '');
        formData.set("address", address ?? '');
        formData.set("technical_phone", technicalPhoneNumber ?? '');
        formData.set("type", placeType ?? '');
        formData.set("biography", biography ?? '');
        formData.set("is_active", isActive);

        Object.entries(departmentFieldValues).forEach(([key, value]) => {
            if (fieldExceptions.includes(key)) return;
            formData.set(key, value ?? '')
        });

        placePhoto && formData.set("files[]", placePhoto.target.files[0]);

        axios
            .post(
                serverConfig.server.url + apiConfig.api.updateAPIs.updatePlace + placeID,
                formData,
                { headers }
            )
            .then((response) => {
                setLoading(false);
                if (response.data.status === "success") {
                    toast.success(response.data.message);
                    setEditing(false);
                    setClearData(true);
                    resetDepartmentFieldValues()
                    getPlacesAPI();
                    navigate("/place-store");
                } else {
                    if (typeof response.data.errors === typeof "String") {
                        toast.error(response.data.errors);
                    } else {
                        response.data.errors.forEach((element) => {
                            toast.error(element);
                        });
                    }
                }
            })
            .catch((error) => {
                setLoading(false);

                toast.error("Error making API call:", error);
            });
    };

    const placeDeleteAPI = () => {
        setLoading(true);
        axios
            .get(
                serverConfig.server.url +
                apiConfig.api.deleteAPIs.deletePlace +
                placeID,
                {
                    headers,
                }
            )
            .then((response) => {
                setLoading(false);
                if (response.data.status === "success") {
                    toast.success(response.data.message);
                    setEditing(false);
                    setClearData(true);
                    getPlacesAPI();
                    navigate("/place-store");
                } else {
                    if (typeof response.data.errors === typeof "String") {
                        toast.error(response.data.errors);
                    } else {
                        response.data.errors.forEach((element) => {
                            toast.error(element);
                        });
                    }
                }
            })
            .catch((error) => {
                setLoading(false);

                toast.error("Error making API call:", error);
            });
    };

    const stateAPI = () => {
        setLoading(true);
        axios
            .get(
                serverConfig.server.url + apiConfig.api.publicAPIs.getProvincesAndCities
            )
            .then((response) => {
                setLoading(false);
                if (response.data.status === "success") {
                    setProvinces(response.data.data.provinces);
                    setCities(response.data.data.cities);
                } else {
                    if (typeof response.data.errors === typeof "String") {
                        toast.error(response.data.errors);
                    } else {
                        response.data.errors.forEach((element) => {
                            toast.error(element);
                        });
                    }
                }
            })
            .catch((error) => {
                setLoading(false);
                console.error("Error making API call:", error);
            });
    };

    const getPlacesAPI = () => {

        setLoading(true)

        axios
            .post(
                serverConfig.server.url +
                apiConfig.api.getAPIs.getPlaces +
                "?page=" +
                currentPage,
                {
                    per_page: perPage,
                    ...(isWhitespaceString(searchValue) && { search_value: searchValue }),
                    pagination: true,
                },
                { headers }
            )
            .then((response) => {
                setLoading(false);
                if (response.data.status === "success") {
                    response.data.data.places && setPlaces(response.data.data.places);

                    // pagination
                    setPaginationElem();
                    setPageCount(response.data.data.page_count);
                    for (let i = 1; i <= response.data.data.page_count; i++) {
                        setPaginationElem((prevPaginationElem) => (
                            <>
                                {prevPaginationElem}
                                <li
                                    className={"page-item" + (currentPage == i ? " active" : "")}
                                >
                                    <a
                                        className="page-link"
                                        href="#"
                                        onClick={() => {
                                            setCurrentPage(i);
                                            scrollToTop();
                                        }}
                                    >
                                        {i}
                                    </a>
                                </li>
                            </>
                        ));
                    }
                } else {
                    if (typeof response.data.errors === typeof "String") {
                        toast.error(response.data.errors);
                    } else {
                        response.data.errors.forEach((element) => {
                            toast.error(element);
                        });
                    }
                }
            })
            .catch((error) => {
                setLoading(false);
                toast.error("Error making API call:", error);
            }).finally(() => setInitialLoad(false))
    };

    const getPlaceProfileAPI = () => {
        setLoading(true);
        axios
            .get(serverConfig.server.url + apiConfig.api.getAPIs.getPlace + placeID, {
                headers,
            })
            .then((response) => {
                setLoading(false);
                if (response.data.status === "success") {
                    setPlaceName(response.data.data.place.title);
                    setPlaceType(response.data.data.place.type);
                    setSelectedProvince(response.data.data.place.province_id);
                    setSelectedCity(response.data.data.place.city_id);
                    setAddress(response.data.data.place.address);
                    setTechnicalPhoneNumber(response.data.data.place.technical_phone);
                    // if (response.data.data.place.biography)
                    //     setBiography(response.data.data.place.biography);
                    // else setBiography("");
                    if (response.data.data.files.length > 0)
                        response.data.data.files.length > 0 &&
                            setPreview(response.data.data.files);
                    else setPreview();
                    setDepartments(response.data.data.departments_list);
                    setDepartmentsList(response.data.data.departments_list);
                    setIsActive(response.data.data.place.is_active);
                    handleDepartmentFieldUpdate({ ...response?.data?.data?.place })
                } else {
                    if (typeof response.data.errors === typeof "String") {
                        toast.error(response.data.errors);
                    } else {
                        response.data.errors.forEach((element) => {
                            toast.error(element);
                        });
                    }
                }
            })
            .catch((error) => {
                setLoading(false);
                toast.error("Error making API call:", error);
            });
    };

    // #region load deps
    const getDepartmentsAPI = () => {

        setLoading(true);

        axios
            .get(
                serverConfig.server.url +
                apiConfig.api.getAPIs.getDepartmentsForPlace +
                placeID +
                "/departments",
                { headers }
            )
            .then(response => {
                setLoading(false);
                if (response.data.status === "success") {
                    setDepartments(response.data.data.departments_list);
                    setDepartmentsList(response.data.data.departments_list);
                    if (
                        response.data.data.other_departments &&
                        response.data.data.other_departments.length > 0
                    ) {
                        setAllDepartments(response.data.data.other_departments);
                    } else {
                        setAllDepartments();
                    }
                } else {
                    if (typeof response.data.errors === typeof "String") {
                        toast.error(response.data.errors);
                    } else {
                        response.data.errors.forEach((element) => {
                            toast.error(element);
                        });
                    }
                }
            })
            .catch((error) => {
                setLoading(false);
                toast.error("Error making API call:", error);
            });
    };
    // #endregion

    // #region assign dep to place
    const changeDepartment = (department) => {
        if (department.length == 0) {
            setDepartment({ id: null, title: null, biography: null });
        } else {
            setDepartment({
                id: department.id,
                title: department.title,
                biography: department.biography,
            });
        }
    };
    // #endregion

    // #region add dep from place
    const addDepartmentAPI = () => {

        setLoading(true);

        axios
            .post(
                serverConfig.server.url + apiConfig.api.addAPIs.addDepartmentPlace,
                {
                    place_id: placeID,
                    department_id: department.id,
                    ...newDepartmentFieldValues,
                },
                { headers }
            )
            .then((response) => {
                setLoading(false);
                if (response.data.status === "success") {
                    toast.success(response.data.message);
                    getPlaceProfileAPI();
                    getDepartmentsAPI();
                    backToDepartmentListModal.current.click()
                    resetDepartmentFieldValues()
                } else {
                    if (typeof response.data.errors === typeof "String") {
                        toast.error(response.data.errors);
                    } else {
                        response.data.errors.forEach((element) => {
                            toast.error(element);
                        });
                    }
                }
            })
            .catch((error) => {
                setLoading(false);
                toast.error("Error making API call:", error);
            });
    };
    // #endregion

    const removeDepartmentAPI = (placeId, departmentId) => {

        setLoading(true);

        axios
            .post(
                serverConfig.server.url +
                apiConfig.api.deleteAPIs.deleteDepartmentPlace,
                {
                    place_id: placeId,
                    department_id: departmentId,
                },
                { headers }
            )
            .then((response) => {
                setLoading(false);
                if (response.data.status === "success") {
                    toast.success(response.data.message);
                    refreshDepartmentList()
                } else {
                    if (typeof response.data.errors === typeof "String") {
                        toast.error(response.data.errors);
                    } else {
                        response.data.errors.forEach((element) => {
                            toast.error(element);
                        });
                    }
                }
            })
            .catch((error) => {
                setLoading(false);
                toast.error("Error making API call:", error);
            });

    };

    const refreshDepartmentList = () => {
        getPlaceProfileAPI();
        getDepartmentsAPI();
    };

    const updateDepartmentPlace = () => {
        setLoading(true);
        axios
            .post(
                serverConfig.server.url +
                apiConfig.api.updateAPIs.updateDepartmentPlace,
                {
                    ...newDepartmentFieldValues,
                    place_id: placeID,
                    department_id: newDepartmentFieldValues.id,
                },
                {
                    headers,
                }
            )
            .then((response) => {
                setLoading(false);
                if (response.data.status === "success") {
                    toast.success(response.data.message);
                    setDepartmentsList(prev => prev.map(dp => dp.id === newDepartmentFieldValues?.id ? { ...newDepartmentFieldValues } : dp))
                    backToDepartmentListModal.current.click()
                } else {
                    if (typeof response.data.errors === typeof "String") {
                        toast.error(response.data.errors);
                    } else {
                        response.data.errors.forEach((element) => {
                            toast.error(element);
                        });
                    }
                }
            })
            .catch(error => {
                setLoading(false);
                toast.error("Error making API call:", error);
            });
    };

    useEffect(() => {
        if (placePhoto) {
            // create the preview
            const objectUrl = URL.createObjectURL(placePhoto.target.files[0]);
            setPreview(objectUrl);

            // free memory when ever this component is unmounted
            return () => URL.revokeObjectURL(objectUrl);
        }
    }, [placePhoto]);

    useEffect(() => {

        const checkLoginStatus = async () => {

            setLoading(true);

            try {

                const loggedIn = await IsLogin();
                setLogIn(loggedIn !== false);

                if (!token && tokenLocal) {
                    dispatch(setUser({ token: tokenLocal, roles: loggedIn }));
                }

                if (loggedIn === false || loggedIn === "error api") {

                    localStorage.getItem("FullName") && localStorage.removeItem("FullName");
                    localStorage.getItem("mobile") && localStorage.removeItem("mobile");
                    localStorage.getItem("token") && localStorage.removeItem("token");
                    localStorage.setItem("callBackURL", window.location.pathname + window.location.search);
                    navigate("/login");

                } stateAPI();

            } catch (error) {
                console.error("Error checking login status:", error);
            }
            finally { setLoading(false) }
        };

        checkLoginStatus();

    }, []);

    // pagination
    useEffect(() => {
        getPlacesAPI();
    }, [currentPage]);

    useEffect(() => {
        setCurrentPage(1);
        getPlacesAPI();
    }, [searchValue, perPage]);

    useEffect(() => {
        if (clearData) {
            setPlaceName("");
            setBiography("");
            setPreview();
            setPlaceType("");
            setPlaceID("");
            setAddress("");
            setTechnicalPhoneNumber("");
            setIsActive(0);
            setSelectedCity("");
            setSelectedProvince("");
            setSelectedDeposit("");
            setClearData(false);
            resetDepartmentFieldValues()
        }
    }, [clearData]);

    useEffect(() => {
        if (editing) {
            getPlaceProfileAPI();
            getDepartmentsAPI();
        }
    }, [editing, placeID]);

    useEffect(() => {
        // Focus on the department search input when the modal is opened
        if (departmentSearchInputRef.current) {
            departmentSearchInputRef.current.focus();
        }
    }, []);

    useEffect(() => {
        if (pl) {
            setEditing(true);
            setPlaceID(pl);
        }
    }, [pl]);

    return (
        <div className="d-flex row pt-3">
            <div>
                {
                    initialLoad
                        ?
                        <div className="tw-space-y-3">
                            <CreatePlaceSkt />
                            <PlaceSkt />
                        </div>
                        :
                        <>
                            {
                                logIn
                                &&
                                (haveAccess(roles, "place_add") || haveAccess(roles, "place_edit"))
                                &&
                                <div className="card card-box-shadow border-0 mb-3">

                                    <div className="card-body d-flex row">

                                        <h5>ثبت مرکز درمانی</h5>
                                        {/* preview image */}
                                        {
                                            preview ?
                                                <div className="d-flex col my-2 col-12 position-relative">
                                                    <img
                                                        className="w-100 object-fit-cover"
                                                        height={350}
                                                        src={preview}
                                                        alt=""
                                                    />
                                                    <div
                                                        className="card position-absolute border-0 delete-card p-2"
                                                        onClick={() => {
                                                            setPlacePhoto();
                                                            setPreview();
                                                        }}
                                                    >
                                                        <DeleteIcon width={24} />
                                                    </div>
                                                </div>
                                                :
                                                <div className="d-flex col my-2 col-12">
                                                    <img
                                                        className="w-100 object-fit-cover"
                                                        height={350}
                                                        src={PlaceImgNotFound}
                                                        alt=""
                                                    />
                                                </div>
                                        }

                                        {/* select image */}
                                        <div className="d-flex col flex-column my-2 col-12">
                                            <div className="d-flex">
                                                <input
                                                    className="form-control"
                                                    type="file"
                                                    id="formFile"
                                                    accept=".png,.jpg,.jpeg,.svg"
                                                    onChange={setPlacePhoto}
                                                />
                                            </div>
                                            <span className="text-secondary fs-14 fw-normal">
                                                حداکثر حجم مجاز عکس 5 مگابایت میباشد
                                            </span>
                                        </div>

                                        <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4 *:tw-w-full tw-mt-4 *:tw-h-min">

                                            <FloatLabelInput
                                                title="نام مرکز درمانی"
                                                fieldKey={'title'}
                                                value={departmentFieldValues.title ?? ''}
                                                onUpdate={handleDepartmentFieldUpdate}
                                            />

                                            <div className="d-flex col my-2 col-lg-6 col-12">
                                                <div
                                                    className="background-bootstrap-gray-100 align-items-center border-radius-8 w-100 d-flex">
                                                    <label
                                                        className="form-check-label ms-2 w-100 p-2 px-1"
                                                        htmlFor="activePlace"
                                                    >
                                                        فعال بودن مرکز درمانی
                                                    </label>

                                                    <div className="form-check form-switch">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            id="activePlace"
                                                            onChange={e => setIsActive(e.target.checked ? 1 : 0)}
                                                            checked={Boolean(isActive)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="d-flex col my-2 col-12 col-lg-6">
                                                <select
                                                    className="form-select"
                                                    aria-label="استان"
                                                    value={selectedProvince ?? ''}
                                                    onChange={(e) => {
                                                        setSelectedProvince(e.target.value);
                                                    }}
                                                >
                                                    <option value="" disabled>
                                                        استان را انتخاب کنید
                                                    </option>
                                                    {provinces &&
                                                        provinces.map((e) => (
                                                            <option key={e.id} value={e.id}>
                                                                {e.name}
                                                            </option>
                                                        ))}
                                                </select>
                                            </div>

                                            <div className="d-flex col my-2 col-12 col-lg-6">
                                                <select
                                                    className="form-select"
                                                    aria-label="شهر"
                                                    value={selectedCity && selectedProvince ? selectedCity : ""}
                                                    onChange={(e) => {
                                                        setSelectedCity(e.target.value);
                                                    }}
                                                >
                                                    <option value="" disabled>
                                                        شهر را انتخاب کنید
                                                    </option>

                                                    {cities &&
                                                        selectedProvince &&
                                                        cities
                                                            .filter((e) => e.province_id == selectedProvince)
                                                            .map((e) => (
                                                                <option key={e.id} value={e.id}>
                                                                    {e.name}
                                                                </option>
                                                            ))}
                                                </select>
                                            </div>

                                            <FloatLabelInput
                                                title="آدرس دقیق"
                                                fieldKey={'address'}
                                                value={departmentFieldValues.address ?? ''}
                                                onUpdate={handleDepartmentFieldUpdate}
                                            />

                                            {/* tech phone number */}
                                            <FloatLabelInput
                                                title="تلفن تماس"
                                                fieldKey={'technical_phone'}
                                                value={departmentFieldValues.technical_phone ?? ''}
                                                onUpdate={handleDepartmentFieldUpdate}
                                            />

                                            <FloatLabelInput
                                                title="توضیحات مرکز (اختیاری)"
                                                fieldKey={'biography'}
                                                value={departmentFieldValues.biography ?? ''}
                                                onUpdate={handleDepartmentFieldUpdate}
                                            />

                                            {/* Type of place */}
                                            <div className="d-flex col my-2 col-12 col-lg-6">
                                                <select
                                                    className="form-select"
                                                    aria-label="نوع مرکز درمانی"
                                                    value={placeType ?? ''}
                                                    onChange={(e) => {
                                                        setPlaceType(e.target.value);
                                                    }}
                                                >
                                                    <option value="" disabled>
                                                        نوع مرکز درمانی را انتخاب کنید
                                                    </option>
                                                    {constData.placeTypes &&
                                                        constData.placeTypes.map((e, index) => (
                                                            <option key={index} value={e.id}>
                                                                {e.name}
                                                            </option>
                                                        ))}
                                                </select>
                                            </div>

                                            <div className="tw-flex tw-flex-col tw-gap-4">

                                                <div className="alert alert-warning p-1 fs-12 my-0 tw-ml-auto tw-w-fit">
                                                    توضیحات در شناخت بهتر مخاطب از مکان و خدمات شما تاثیر بالایی
                                                    دارد
                                                </div>

                                                <p className="tw-text-red-600 tw-m-0">تمامی مبالغ زیر به تومان می باشد.</p>

                                            </div>

                                            <span></span>

                                            <div className="d-flex col mb-1 col-lg-6 col-12 tw-mt-auto">
                                                <select
                                                    className="form-select"
                                                    aria-label="درصد بیعانه"
                                                    value={departmentFieldValues?.deposit_percentage ?? ''}
                                                    onChange={e => handleDepartmentFieldUpdate(prev => ({ ...prev, deposit_percentage: e.target?.value }))}
                                                >
                                                    {depositOptions.map((option) => (
                                                        <option key={option.value} value={option.value} disabled={option.disabled}>
                                                            {option.label}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            <FloatLabelInput
                                                title={"هزینه خدمات پذیرکس برای بیمار"}
                                                fieldKey="pazirex_patient_service_amount"
                                                onUpdate={handleDepartmentFieldUpdate}
                                                value={departmentFieldValues?.pazirex_patient_service_amount ?? ''}
                                            />

                                            <FloatLabelInput
                                                title={"هزینه خدمات پذیرکس برای پزشک"}
                                                fieldKey="pazirex_provider_service_amount"
                                                onUpdate={handleDepartmentFieldUpdate}
                                                value={departmentFieldValues?.pazirex_provider_service_amount ?? ''}
                                            />

                                            <FloatLabelInput
                                                title={"هزینه کل ویزیت"}
                                                fieldKey="total_visit_amount"
                                                onUpdate={handleDepartmentFieldUpdate}
                                                value={departmentFieldValues?.total_visit_amount ?? ''}
                                            />

                                        </div>

                                        {/* Departments list */}
                                        {
                                            editing && (
                                                <>
                                                    {
                                                        allDepartments && haveAccess(roles, "place_department_add") && (
                                                            <div className="d-flex col my-2 col-12 col-lg-6">
                                                                <div className="d-flex row w-100 m-0">
                                                                    <div
                                                                        onClick={() => setIsDepartmentUpdating(false)}
                                                                        className="btn btn-outline-active d-flex align-items-center"
                                                                        data-bs-toggle="modal"
                                                                        data-bs-target="#department-modal"
                                                                    >
                                                                        اختصاص دپارتمان
                                                                        <img
                                                                            src={AddIcon}
                                                                            className="ms-auto"
                                                                            width={20}
                                                                            alt=""
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    }

                                                    <div className="d-flex row g-3 mt-0">
                                                        {
                                                            departmentsList && departmentsList.map((department, index) => (
                                                                <div key={index} className="col-lg-4 col-12">
                                                                    <DepartmentPlaceCard
                                                                        placeId={placeID}
                                                                        placeTitle={placeName}
                                                                        departmentId={department.id}
                                                                        departmentTitle={department.title}
                                                                        files={department.files}
                                                                        departmentBio={department.biography}
                                                                        departmentPhone={department.phone}
                                                                        alldata={department}
                                                                        onRemoveDepartment={() => removeDepartmentAPI(placeID, department.id)}
                                                                        onEditModal={() => {
                                                                            setIsDepartmentUpdating(true)
                                                                            handleNewDepartmentFieldUpdate({ ...department })
                                                                        }}
                                                                    />
                                                                </div>
                                                            ))
                                                        }
                                                    </div>

                                                </>
                                            )
                                        }

                                        {/* Button */}
                                        <div className="d-flex col my-2 col-12">
                                            {
                                                editing ? (
                                                    <>
                                                        {haveAccess(roles, "place_edit") && (
                                                            <div className="d-flex col-auto">
                                                                <button
                                                                    type="button"
                                                                    className={`btn btn-link color-bootstrap-regular-danger text-decoration-none w-100 px-4 ms-12px fw-medium${loading ? " disabled" : ""
                                                                        }`}
                                                                    onClick={placeDeleteAPI}
                                                                >
                                                                    حذف
                                                                </button>
                                                            </div>
                                                        )}

                                                        <div className="d-flex col">
                                                            <button
                                                                type="button"
                                                                className="btn btn-outline-primary w-100 mx-12px fw-medium"
                                                                onClick={() => {
                                                                    setClearData(true);
                                                                    setEditing(false);
                                                                    setDepartmentFieldValues(prev => (prev, {
                                                                        pazirex_patient_service_amount: '',
                                                                        pazirex_provider_service_amount: '',
                                                                        total_visit_amount: '',
                                                                        deposit_percentage: ''
                                                                    }))
                                                                    navigate("/place-store");
                                                                }}
                                                            >
                                                                انصراف
                                                            </button>
                                                        </div>

                                                        <div className="d-flex col">
                                                            <button
                                                                type="button"
                                                                className={`btn btn-primary w-100 me-12px fw-medium${loading ? " disabled" : ""
                                                                    }`}
                                                                onClick={placeUpdateAPI}
                                                            >
                                                                تایید
                                                            </button>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <button
                                                        type="button"
                                                        className={`btn btn-primary w-100 ${loading ? " disabled" : ""}`}
                                                        onClick={placeStoreAPI}
                                                    >
                                                        ثبت مرکز درمانی
                                                    </button>
                                                )}
                                        </div>

                                    </div>

                                </div>
                            }

                            <div>
                                <div className="card card-box-shadow border-0 mb-3">
                                    <div className="card-body d-flex flex-column">
                                        <div className="d-flex align-items-center mb-2">
                                            <p className="col fs-18 fw-medium w-auto m-0">
                                                لیست مراکز درمانی
                                            </p>
                                            <div className="d-flex w-auto">
                                                <input
                                                    className="form-control ms-1 col"
                                                    type="text"
                                                    placeholder="جستجوی نام مکان"
                                                    value={searchValue ?? ''}
                                                    onChange={(e) => {
                                                        setSearchValue(e.target.value);
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex row g-3 mx-auto">
                                    {
                                        places?.map((place, index) => (
                                            <div className="col-lg-6 col-12" key={place.id}>
                                                <PlaceCard
                                                    {...place}
                                                    key={index}
                                                />
                                            </div>
                                        ))
                                    }
                                    <nav aria-label="Page navigation example">
                                        <ul className="pagination">
                                            {currentPage !== 1 && (
                                                <li className="page-item">
                                                    <a
                                                        className="page-link"
                                                        disabled
                                                        href="#"
                                                        aria-label="Previous"
                                                        onClick={() => {
                                                            setCurrentPage(currentPage - 1);
                                                            scrollToTop();
                                                        }}
                                                    >
                                                        <span>&laquo;</span>
                                                    </a>
                                                </li>
                                            )}
                                            {paginationElem}
                                            {pageCount != currentPage && (
                                                <li className="page-item">
                                                    <a
                                                        className="page-link"
                                                        disabled
                                                        href="#"
                                                        aria-label="Next"
                                                        onClick={() => {
                                                            setCurrentPage(currentPage + 1);
                                                            scrollToTop();
                                                        }}
                                                    >
                                                        <span>&raquo;</span>
                                                    </a>
                                                </li>
                                            )}
                                        </ul>
                                    </nav>
                                </div>
                            </div>

                        </>
                }

            </div>

            {/* add or update detail of added department modal */}
            <div
                className="modal fade"
                id={`detail-modal`}
            >
                <div className="modal-dialog modal-dialog-scrollable">

                    <div className="modal-content tw-p-0">

                        <div className="modal-header tw-flex tw-flex-col tw-gap-1 tw-items-start tw-border-none tw-w-full mx-0 tw-pl-2 py-2 color-bootstrap-gray-800 tw-relative">
                            <div className="tw-flex tw-justify-between tw-items-center tw-w-full">
                                <span className="w-100 tw-text-[#212529] tw-text-[16px] tw-font-medium">اطلاعات دپارتمان</span>
                                <Close
                                    className="tw-size-6 tw-flex-grow tw-flex-shrink-0"
                                    type="button"
                                    data-bs-dismiss="modal"
                                />
                            </div>
                            <span className="tw-absolute tw-h-px tw-inset-x-0 tw-bottom-0 border-bottom tw-m-auto !tw-w-[95%]"></span>
                            <p className="tw-text-sm tw-font-normal tw-text-[#495057] tw-m-0">{department.title}</p>
                        </div>

                        <div className="tw-flex tw-flex-col tw-gap-3 tw-px-3 tw-py-6">

                            <FloatLabelInput
                                title={"شماره موبایل"}
                                fieldKey={'phone'}
                                onUpdate={handleNewDepartmentFieldUpdate}
                                value={newDepartmentFieldValues?.phone ?? ''}
                            />

                            <FloatLabelInput
                                title={"توضیحات دپارتمان (اختیاری)"}
                                fieldKey={'biography'}
                                onUpdate={handleNewDepartmentFieldUpdate}
                                value={newDepartmentFieldValues?.biography ?? ''}
                            />

                            <div className="d-flex col col-12">
                                <select
                                    className="form-select"
                                    aria-label="درصد بیعانه"
                                    value={newDepartmentFieldValues?.deposit_percentage ?? ''}
                                    onChange={e => handleNewDepartmentFieldUpdate(prev => ({ ...prev, deposit_percentage: e.target.value }))}
                                >
                                    {
                                        depositOptions.map(option => (
                                            <option
                                                key={option.value}
                                                value={option.value}
                                                disabled={option.disabled}
                                            >
                                                {option.label}
                                            </option>
                                        ))
                                    }
                                </select>
                            </div>

                            <FloatLabelInput
                                title={"هزینه خدمات پذیرکس برای بیمار"}
                                fieldKey="pazirex_patient_service_amount"
                                onUpdate={handleNewDepartmentFieldUpdate}
                                value={newDepartmentFieldValues?.pazirex_patient_service_amount ?? ''}
                            />

                            <FloatLabelInput
                                title={"هزینه خدمات پذیرکس برای پزشک"}
                                fieldKey="pazirex_provider_service_amount"
                                onUpdate={handleNewDepartmentFieldUpdate}
                                value={newDepartmentFieldValues?.pazirex_provider_service_amount ?? ''}
                            />

                            <FloatLabelInput
                                title={"هزینه کل ویزیت"}
                                fieldKey="total_visit_amount"
                                onUpdate={handleNewDepartmentFieldUpdate}
                                value={newDepartmentFieldValues?.total_visit_amount ?? ''}
                            />

                        </div>

                        <div className="tw-flex tw-items-center tw-gap-2 tw-h-[72px] tw-relative tw-p-3">

                            <span className="tw-absolute tw-top-0 tw-inset-x-0 tw-bg-[#ADB5BD] tw-h-[1px] tw-w-full down-menu-drop"></span>

                            <button
                                className="btn btn-primary w-100 d-flex align-items-center justify-content-center"
                                disabled={loading}
                                onClick={isDepartmentUpdating ? updateDepartmentPlace : addDepartmentAPI}
                            >
                                {isDepartmentUpdating ? 'بروزرسانی' : 'ثبت'}
                            </button>

                            <button
                                className="btn tw-text-[#0360D9] tw-border-[#0360D9] w-100 d-flex align-items-center justify-content-center"
                                ref={backToDepartmentListModal}
                                {...(isDepartmentUpdating
                                    ?
                                    { 'data-bs-dismiss': 'modal' }
                                    :
                                    { 'data-bs-toggle': 'modal', 'data-bs-target': `#department-modal` }
                                )}
                            >
                                بازگشت
                            </button>

                            {
                                isDepartmentUpdating && (
                                    <div
                                        data-bs-dismiss="modal"
                                        onClick={() => removeDepartmentAPI(placeID, newDepartmentFieldValues.id)}
                                        className="btn tw-size-10 tw-rounded-lg tw-p-2 tw-flex tw-items-center tw-justify-center tw-border-[#F83234] tw-flex-grow tw-flex-shrink-0"
                                    >
                                        <Delete className="tw-text-red-500" />
                                    </div>
                                )
                            }

                        </div>

                    </div>

                </div>

            </div >

            {/* select department modal */}
            <div
                className="modal fade"
                id="department-modal"
            >
                <div className="modal-dialog modal-dialog-scrollable">
                    <div className="modal-content">

                        <div className="modal-header border-bottom mx-0 py-2">
                            <ArrowRightAltIcon
                                className="color-bootstrap-gray-800"
                                width={24}
                                height={24}
                                type="button"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            />
                            <input
                                type="text"
                                className="form-control border-0 shadow-none w-100 color-iso-gray"
                                id="department-search-input"
                                autoFocus={true}
                                placeholder="انتخاب دپارتمان ..."
                                value={departmentSearch ?? ''}
                                onChange={(e) => setDepartmentSearch(e.target.value)}
                                ref={departmentSearchInputRef} // Assign the ref to the input field
                            />
                        </div>

                        <div className="modal-body">
                            <div className="d-flex flex-column align-items-start">
                                {
                                    allDepartments && allDepartments.filter(e => e.title.includes(departmentSearch))
                                        .map((department, index) => (
                                            <button
                                                className="btn btn-light w-100 d-flex align-items-start my-2"
                                                data-bs-toggle="modal"
                                                data-bs-target="#detail-modal"
                                                key={index}
                                                onClick={() => {
                                                    handleNewDepartmentFieldUpdate({ ...departmentFieldValues, biography: '', phone: departmentFieldValues.technical_phone })
                                                    changeDepartment(department);
                                                }}
                                            >
                                                {department.title}
                                            </button>
                                        ))
                                }
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </div>

    );

};

export default PlaceStore;